import type { AddCreditCardData } from '@/types/clientDetailsApiTypes';

export const getRequestPayloadForVault = (data: Omit<AddCreditCardData, 'token' | 'reference'>) => {
  const formatCardNumber = (num: string) => {
    if (!num) return '';
    return num
      .replace(/\D/g, '')
      .replace(/(.{4})/g, '$1 ')
      .trim();
  };

  // Format expiry: convert "MMYY" or "MM/YYYY" or "MM/YY" to "MM/YY"
  const formatExpiry = (expiry: string) => {
    if (!expiry) return '';
    if (expiry.includes('/')) {
      const [mm, yy] = expiry.split('/');
      if (yy.length === 2) return `${mm.padStart(2, '0')}/${yy}`;
      if (yy.length === 4) return `${mm.padStart(2, '0')}/${yy.slice(-2)}`;
    }
    if (/^\d{4}$/.test(expiry)) {
      return `${expiry.slice(0, 2)}/${expiry.slice(2, 4)}`;
    }
    if (/^\d{6}$/.test(expiry)) {
      return `${expiry.slice(0, 2)}/${expiry.slice(4, 6)}`;
    }
    return expiry;
  };

  const getExpiryParts = (expiry: string) => {
    let mm = '',
      yyyy = '',
      yy = '';
    if (!expiry) return { mm, yyyy, yy };
    if (expiry.includes('/')) {
      const [m, y] = expiry.split('/');
      mm = m.padStart(2, '0');
      if (y.length === 2) {
        yy = y;
        yyyy = `20${y}`;
      } else if (y.length === 4) {
        yyyy = y;
        yy = y.slice(-2);
      }
    } else if (/^\d{4}$/.test(expiry)) {
      mm = expiry.slice(0, 2);
      yy = expiry.slice(2, 4);
      yyyy = `20${yy}`;
    } else if (/^\d{6}$/.test(expiry)) {
      mm = expiry.slice(0, 2);
      yyyy = expiry.slice(2, 6);
      yy = yyyy.slice(-2);
    }
    return { mm, yyyy, yy };
  };

  const lastFour = data.last4 || data.card_number?.slice(-4) || '';
  const formattedCardNumber = formatCardNumber(data.card_number);
  const formattedExpiry = formatExpiry(data.expiry_date);
  const { mm, yyyy, yy } = getExpiryParts(data.expiry_date);

  return {
    card_holder: data.cardholder_name,
    card_number: formattedCardNumber,
    card_type: data.card_type,
    cvv: data.cvv,
    expiry: formattedExpiry,
    expiry_month: mm,
    expiry_year: yyyy,
    expiry_year_short: yy,
    last_four: lastFour,
  };
};
